/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IconSet } from '../models/IconSet';
import type { SetInformationEnhanced } from '../models/SetInformationEnhanced';
import type { SVG } from '../models/SVG';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class IconsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get All Icon Metadata
     * @returns SetInformationEnhanced Successful Response
     * @throws ApiError
     */
    public getAllIconMetadataApiV1IconsMetadataPackAllGet({
        pack,
    }: {
        pack: IconSet,
    }): CancelablePromise<SetInformationEnhanced> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/icons/metadata/{pack}/all',
            path: {
                'pack': pack,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Icon Names
     * @returns string Successful Response
     * @throws ApiError
     */
    public getAllIconNamesApiV1IconsNamesAllGet(): CancelablePromise<Array<string>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/icons/names/all',
        });
    }
    /**
     * Get All Svg Metadata
     * @returns SVG Successful Response
     * @throws ApiError
     */
    public getAllSvgMetadataApiV1IconsSvgAllMetaGet(): CancelablePromise<Record<string, SVG>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/icons/svg/all/meta',
        });
    }
    /**
     * Get Svg Metadata Batch
     * Several icons at once, keyed by the requested name. Names which are no icon are left out of the result,
     * so the caller can tell which ones failed without losing the rest.
     * @returns SVG Successful Response
     * @throws ApiError
     */
    public getSvgMetadataBatchApiV1IconsSvgBatchGet({
        names,
    }: {
        /**
         * Dotted icon names, e.g. `fa.thumbs-up.solid`.
         */
        names: Array<string>,
    }): CancelablePromise<Record<string, SVG>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/icons/svg/batch',
            query: {
                'names': names,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Icon Svg Metadata
     * @returns SVG Successful Response
     * @throws ApiError
     */
    public getIconSvgMetadataApiV1IconsSvgPackNameFlavorMetaGet({
        pack,
        name,
        flavor,
    }: {
        pack: string,
        name: string,
        flavor: string,
    }): CancelablePromise<SVG> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/icons/svg/{pack}.{name}.{flavor}/meta',
            path: {
                'pack': pack,
                'name': name,
                'flavor': flavor,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Icon Svg
     * @returns any Successful Response
     * @throws ApiError
     */
    public getIconSvgApiV1IconsSvgPackNameFlavorGet({
        pack,
        name,
        flavor,
    }: {
        pack: string,
        name: string,
        flavor: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/icons/svg/{pack}.{name}.{flavor}',
            path: {
                'pack': pack,
                'name': name,
                'flavor': flavor,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
